import React, {Component} from "react";
import axios from "axios";
import Loading from "../../Loading";
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import VcbSalePerformanceUploadRow from "./VcbSalePerformanceUploadRow";

class VcbSalePerformanceUploadList extends Component{
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            errorMessage: '',
            items: [],
            rows: [],
            itemPerPage: 10,
            totalPages: 0,
            currentPage: 1
        }
        this.renderRows = this.renderRows.bind(this);
        this.handleClickPreviousButton = this.handleClickPreviousButton.bind(this);
        this.handleClickNextButton = this.handleClickNextButton.bind(this);
        this.handleChangeItemPerPage = this.handleChangeItemPerPage.bind(this);
    }

    componentDidMount() {
        console.log('load init data contest');
        this.setState({isLoading: true})
        axios.get('/api/bankportal/report/vcb/salePerformance/upload/list')
            .then(response => !!response.data?.listUpload
                ? this.renderRows(response.data?.listUpload,10,1)
                : this.setState({ items: [], errorMessage: 'Không tìm thấy dữ liệu báo cáo !',isLoading: false})
            )
            .catch(error => {
                this.setState({ items: [],errorMessage: error.message,isLoading: false });
                console.error('There was an error!', error);
            })
    }

    renderRows = (items,itemPerPage,currentPage) =>{
        const prevPage = currentPage - 1;
        const rows = items?.slice(prevPage  * itemPerPage, currentPage * itemPerPage);
        const totalPages = Math.floor((items || []).length / itemPerPage + 1)
        this.setState({items:items, rows: rows, totalPages: totalPages,errorMessage:'',isLoading: false});
    }

    handleChangeItemPerPage(e){
        const {items} = this.state;
        this.setState({currentPage: 1, itemPerPage: e.target.value, totalPages: Math.floor((this.state.items || []).length / e.target.value + 1)});
        this.renderRows(items,e.target.value, 1);
    }
    handleClickPreviousButton() {
        const {items,itemPerPage,currentPage} = this.state
        const prevPage = currentPage - 1
        if(prevPage > 0){
            this.setState({currentPage: prevPage})
            this.renderRows(items,itemPerPage,prevPage);
        }
    }
    handleClickNextButton() {
        const {items,itemPerPage,currentPage,totalPages} = this.state
        const nextPage = currentPage + 1
        if(nextPage <= totalPages){
            this.setState({currentPage: nextPage});
            this.renderRows(items,itemPerPage,nextPage);
        }
    }

    render(){
        const { isLoading,errorMessage,rows,totalPages,currentPage,itemPerPage } = this.state;
        const renderPreviousButton = () => {
            console.log('currentPage:'+currentPage);
            if(currentPage <= 1) return null;
            return(
                <a className='text-primary bp-paging-link' onClick={this.handleClickPreviousButton} > {'<< '}Trước</a>
            )
        }
        const renderNextButton = () => {
            if(currentPage >= totalPages) return null;
            return (
                <a className='text-primary bp-paging-link' onClick={this.handleClickNextButton}>Sau {' >>'}</a>
            )
        }
        const renderItemPerPage = () => {
            return (
                <div className='input-group'>
                    <label className='input-group-text bg-white border-0 font-weight-bold'>Số hàng mỗi trang</label>
                    <select value={itemPerPage} onChange={this.handleChangeItemPerPage} className='form-control'>
                        <option>5</option>
                        <option>10</option>
                        <option>20</option>
                        <option>50</option>
                        <option>100</option>
                    </select>
                </div>
            )
        }
        const renderPageIndex = () => {
            if(totalPages <= 0) return null;
            return(<span>Trang {currentPage} / {totalPages}</span>)
        }
        const renderPaging = () => {
            return (
                <div className='d-flex justify-content-between align-items-center'>
                        <div>{renderPreviousButton()}</div>
                        <div>{renderItemPerPage()}</div>
                        <div>{renderPageIndex()}</div>
                        <div>{renderNextButton()}</div>
                </div>
            )
        }
        return(
            <div className={'report mx-5'}>
                { isLoading && <Loading /> }
                { <Link to={'/bp/salePerformance/upload/create'} className={'btn btn-success mt-2'}>Tạo mới File Upload</Link> }
                <h2 className={'m-3 text-primary'}>DANH SÁCH CÁC FILE UPLOAD - VCB</h2>
                <table className={'table table-bordered table-hover'}>
                    <thead className='bg-secondary text-white'>
                    <tr>
                        <th>STT</th>
                        <th>Ngân hàng</th>
                        <th>Tên báo cáo</th>
                        <th>Loại báo cáo</th>
                        <th>Ngày báo cáo</th>
                        <th>Trạng thái</th>
                        <th>Upload by</th>
                        <th>Ngày tạo</th>
                        <th>Ngày cập nhật</th>
                    </tr>
                    </thead>
                    <tbody>
                        {!!rows && rows.map((item, index) => <VcbSalePerformanceUploadRow key={item?.bankCode+'_'+item?.id} item={item} index={index+((currentPage - 1) * itemPerPage)} />)}
                    </tbody>
                </table>
                {renderPaging()}
                { !!errorMessage && <div className={"alert alert-warning"} role="alert">{ errorMessage }</div> }
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    const authorities = state?.auth?.authorities;
    const isRoleHO = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_HO');
    const isRoleFWDContest = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_BP_CONTEST');
    const isRoleBO = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_BO');
    const isRoleTO = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_TO');
    const username = state?.auth?.name;
    return { username,isRoleHO, isRoleFWDContest, isRoleBO, isRoleTO };
};

export default connect(mapStateToProps)(VcbSalePerformanceUploadList);